import { render, staticRenderFns } from "./ConfigureTwoFactorAuth.vue?vue&type=template&id=365d5db0&scoped=true&"
import script from "./ConfigureTwoFactorAuth.vue?vue&type=script&lang=js&"
export * from "./ConfigureTwoFactorAuth.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureTwoFactorAuth.vue?vue&type=style&index=0&id=365d5db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d5db0",
  null
  
)

export default component.exports